<div class="expanded-panel-header gray">Notes</div>

<p>{{detail.notes}}</p>
